import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { opuKeys } from '../queries/keys';
import { opuPaths } from '../queries/paths';

// TSS vite/03 — server-state hooks for OPU sessions
// (api-reference/admin-aspiration-sessions.md).

export function useOpuList(filters) {
    return useQuery({
        queryKey: opuKeys.list(filters),
        queryFn:  ({ signal }) => api.get(opuPaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useOpuSession(id, view) {
    return useQuery({
        queryKey: opuKeys.detail(id, view),
        queryFn:  ({ signal }) => api.get(opuPaths.detail(id), { params: view ? { view } : undefined, signal }).then(r => r.data),
        enabled:  !!id && id !== 'new',
    });
}

// GET /:id/transfer-sessions — cadena OPU → transfers (T.E. que usaron sus embriones) + embriones
// disponibles para reanudar (admin-aspiration-sessions.md · 0019). Read-only, aspirations:read.
export function useOpuTransferSessions(id) {
    return useQuery({
        queryKey: opuKeys.transferSessions(id),
        queryFn:  ({ signal }) => api.get(opuPaths.transferSessions(id), { signal }).then(r => r.data),
        enabled:  !!id,
    });
}

// Compound create: session + staff + aspirations in one POST → assigns OPU-N.
export function useCreateOpuSession() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(opuPaths.list(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: opuKeys.all }),
    });
}
